<template>
  <div class="myform">
    <div class="list">
      <div class="top">
        <div class="label">你的姓名</div>
        <div class="val-content">
          <nut-textinput class="input" v-model="formData.cus_name" placeholder="请输入真实姓名" :clearBtn="false"
                         :disabled="false"
                         :has-border="false"/>
        </div>
      </div>
<!--      <div class="prompt" v-if="error.cus_name">-->
<!--        <img src="../assets/images/icon_danger.png" alt="">-->
<!--        <span>请输入真实姓名</span>-->
<!--      </div>-->
    </div>
    <!--<div class="list">
      <div class="top">
        <div class="label">从哪出发</div>
        <div class="val-content">
          <nut-textinput class="input" v-model="formData.address" placeholder="请输入地址" :clearBtn="false"
                         @click="showAddrPopup=true" :disabled="false" :has-border="false"/>
          <img src="../assets/images/icon_address.png" @click="showAddrPopup=true" alt="">
        </div>
      </div>

    </div>-->
    <div class="list">
      <div class="top">
        <div class="label">驾照类型</div>
        <div class="val-content" id="jzlx">
          <select name="drives_type" id="drives-type" style="width: 100%;outline:none;border: 0;height: 30px;font-size:13px;appearance:none;-moz-appearance:none;background:#ffffff;
          -webkit-appearance:none;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-tap-highlight-color: transparent;color: #808080">
            <option value="C1" selected>C1 小型汽车</option>
            <option value="C2">C2 小型自动挡汽车</option>
            <option value="C3">C3 低速载货汽车</option>
            <option value="C4">C4 三轮汽车</option>
            <option value="A1">A1 大型客车</option>
            <option value="A2">A2 牵引车</option>
            <option value="A3">A3 城市公交车</option>
            <option value="B1">B1 中型客车</option>
            <option value="B2">B2 大型货车</option>
            <option value="D">D 普通三轮摩托车</option>
            <option value="E">E 普通二轮摩托车</option>
            <option value="F">F 轻便摩托车</option>
          </select>
          <!-- <nut-textinput class="input" v-model="formData.drives_type" placeholder="请选择驾照类型" :clearBtn="false"
                         :disabled="false" :has-border="false"/> -->
           <img src="../assets/images/icon_right.png" alt="">
        </div>
      </div>
      <!-- <div class="prompt" v-if="error.drives_type">
        <img src="../assets/images/icon_danger.png" alt="">
        <span>请选择正确驾照类型</span>
      </div> -->
    </div>
    <div class="list">
      <div class="top">
        <div class="label">手机号码</div>
        <div class="val-content">
          <nut-textinput class="input" v-model="formData.cus_phone" @keyup="mobileChange" placeholder="此手机号用于车之驭企业版登录"
                         maxlength="11"
                         :clearBtn="false"
                         :disabled="false" :has-border="false"/>
        </div>
      </div>
<!--      <div class="prompt" v-if="error.cus_phone">-->
<!--        <img src="../assets/images/icon_danger.png" alt="">-->
<!--        <span>请输入正确的手机号码</span>-->
<!--      </div>-->
    </div>
    <div class="list" v-show="formData.codeIsShow">
      <div class="top">
        <div class="label">验证码</div>
        <div class="val-content">
          <nut-textinput class="input" v-model="formData.code" placeholder="请输入短信验证码" :clearBtn="false"
                         :disabled="false" :has-border="false"/>
          <span @click="getCode">{{ getCodeText }}</span>
        </div>
      </div>
      <div class="prompt" v-if="error.code">
        <img src="../assets/images/icon_danger.png" alt="">
        <span>请输入正确的验证码</span>
      </div>
    </div>
    <!-- 选择驾照弹窗 -->
    <nut-popup v-model="dPopupShow" position="bottom" :style="{ height: '100%' }">
      <Driving @choose="chooseType"></Driving>
    </nut-popup>

    <nut-address
        v-model="showAddrPopup"
        :province="addr.province"
        :city="addr.city"
        :country="addr.country"
        customAddressTitle="请选择所在地区"
        @onChange="onChangeAddr"
        @close="closeAddr">
    </nut-address>

  </div>
</template>

<script>
import Packet from '@/components/Packet'
import Driving from '@/components/Driving.vue'
import cache from "../utils/cache"

var regionAll = [];
export default {
  name: 'FreeForm',
  components: {Packet, Driving},
  props: {
    source: {
      type: String,
      default: 'find_driving'
    },
    storeid: {
      default: 0
    },
    freeformsubmitsuccess: {
      type: Function
    },
    couponid: {
      default: 0
    }
  },
  data() {
    return {
      showAddrPopup: false,
      addr: {
        province: [{id: 1, name: '北京'}],
        city: [{id: 1, name: '北京'}],
        country: [{id: 1, name: '北京'}],
      },
      getCodeText: '获取验证码',
      userNameText: '',
      userMobileText: '',
      //表单数据
      formData: {
        source: 'find_driving',
        cus_name: '',
        address_id_str: '',
        address: '',
        drives_type: '',
        cus_phone: '',
        code: '',
        codeIsShow: false,
        in_car_longitude:null,
        in_car_latitude:null,
      },
      oldMobile: '',
      //表单数据
      error: {
        cus_name: false,
        address: false,
        drives_type: false,
        cus_phone: false,
        code: false
      },
      dPopupShow: false, //显示选择驾照弹窗
      codeIsShow: false, //控制验证码是否显示
    }
  },
  created() {
    // var script = document.createElement('script');
		// 	script.src = "https://3gimg.qq.com/lightmap/components/geolocation/geolocation.min.js";
    //   document.body.appendChild(script);
    if (!this.$ajax.get_activity_id()) {
      this.$router.push({name: 'Empty', query: {'error': '活动不存在'}});
    } else {
      // this.getRegionAll(() => {
      //   this.getRegion(0, province => {
      //     this.addr.province = province;
      //     this.getRegion(province[0].id, city => {
      //       this.addr.city = city;
      //       this.getRegion(city[0].id, country => {
      //         this.addr.country = country;
      //       })
      //     })
      //   })
      // })
    }
    this.getUserInfo();
    //this.temp();
  },
  methods: {
    getRegionAll(call) {
      let data = cache.get('RegionAll');
      if (data) {
        regionAll = JSON.parse(data);
        call();
      } else {
        this.$ajax.get('m/system/get_region', {
          all: 1
        }).then(res => {
          regionAll = res;
          cache.set('RegionAll', JSON.stringify(res),38640);
          call();
        })
      }
    },
    mobileChange() {
      let reg = /^[1][0-9]{10}$/;
      if (reg.test(this.formData.cus_phone) && this.formData.cus_phone !== this.oldMobile) {
        this.formData.codeIsShow = true;
      } else {
        this.formData.codeIsShow = false;
      }
    },
    getUserInfo() {
      this.$ajax.get('m/trade/my', {id: this.$ajax.get_activity_id()}).then(res => {
        if(res){
          //this.formData.cus_name = res.user.nickname;
          this.formData.cus_phone = res.user.mobile;
          this.oldMobile = res.user.mobile;
        }
      });
    },
    getRegion(parent_id, call) {
      let ret = [];
      for (let i = 0, len = regionAll.length; i < len; i++) {
        if (parseInt(regionAll[i].parent_id) === parseInt(parent_id)) {
          ret.push(regionAll[i]);
        }
      }
      call(ret);
    },
    // 选择驾照类型
    chooseType(value) {

      this.formData.drives_type = value.v;
      this.dPopupShow = false;
    },
    getCode() {
      if (this.getCodeText !== '获取验证码') return;

      this.$ajax.get('m/user/send_sms_code', {
        phone: this.formData.cus_phone,
        Ot: 8,
      }).then(res => {

        let timer, time = 60;
        timer = setInterval(() => {
          if (time <= 0) {
            this.getCodeText = '获取验证码';
            clearInterval(timer);
          } else {
            this.getCodeText = time-- + 's';
          }
        }, 1000)
      })


    },
    onChangeAddr(e) {
      if (e.next === 'town') {
        this.showAddrPopup = false;
      } else {
        this.getRegion(e.value.id, res => {
          this.addr[e.next] = res;
        })
      }
    },
    closeAddr(e) {
      this.formData.address_id_str = e.data.addressIdStr;
      this.formData.address = e.data.addressStr;
    },
    save_cus() {
      this.$ajax.get('m/Resource/save_cus', this.formData).then((res) => {
        if(res){
          this.freeformsubmitsuccess();
          this.$toast.text('提交成功,驾校或教练将会与您联系；');
        }
      })
    },
    submit() {
      this.formData.source = this.source;
      this.formData.drives_type = $('#drives-type option:selected').val();
      if (this.storeid) {
        this.formData.store_id = this.storeid;
      }

      // for (let key in this.formData) {
      //   this.error[key] = !this.formData[key];
      // }




      // if(!this.formData.cus_name || !this.formData.drives_type ||  !this.formData.cus_phone || (this.formData.codeIsShow && !this.formData.code)){
      //   return ;
      // }


      if(!this.formData.cus_name){
        this.$toast.text('请输入真实姓名');
        return ;
      }

      // if(!this.formData.address){
      //   this.$toast.text('请输入正确的地址');
      //   return ;
      // }

      if(!this.formData.cus_phone){
        this.$toast.text('请输入手机号码');
        return ;
      }

      if(this.formData.codeIsShow && !this.formData.code){
        this.$toast.text('请输入验证码');
        return ;
      }

      if (this.couponid) {
        this.formData.coupon_id = this.couponid;

        this.$ajax.get('m/order/add_order', {
          activity_id: this.$ajax.get_activity_id(),
          coupon_id: this.couponid,
          order_prom_type: 1223,
          num: 1
        }).then(order_id => {
          this.save_cus();

        },err=>{
          this.$toast.text(err.message);
          this.freeformsubmitsuccess();
        })

      } else {
        this.save_cus();
      }
    },
    temp(){
      var geolocation = new qq.maps.Geolocation("4UXBZ-LS6KP-SMJDG-LMJTR-7XA4F-7BB4I","studycar");
      var options = {timeout:9000};
      var latitude;
      var longitude;
      var geocoder;
      var latLng
      geolocation.getLocation(showPosition,null,options);
      var that = this;

      function showPosition(position) {
        latitude = position.lat
        longitude = position.lng
        geocoder = new qq.maps.Geocoder();
        latLng = new qq.maps.LatLng(latitude,longitude);
        //经纬度解析
        geocoder.getAddress(latLng);
        //设置服务请求成功回调函数
        geocoder.setComplete(function(rs){
          var rsJson = JSON.parse(JSON.stringify(rs));
          var address = {};
          address.province = rsJson.detail.addressComponents.province;
          address.city = rsJson.detail.addressComponents.city;
          address.district = rsJson.detail.addressComponents.district;
          address.street = rsJson.detail.addressComponents.town + rsJson.detail.addressComponents.street;
          address.longitude = longitude;
          address.latitude = latitude;
          address.addr = address.province + (address.city == address.province ? '' : address.city) + address.district + address.street;
          that.address = address;
          if(address.addr.length > 0){
            that.formData.address = address.addr;
            that.formData.in_car_longitude = address.longitude;
            that.formData.in_car_latitude = address.latitude;
          }
        });
        geocoder.setError(function () {

        })
      }

    }
  },
}
</script>

<style lang="less" scoped>
#jzlx input{
  color: #eb273b;
}



.myform {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 15px 0;

  .list {
    width: 100%;
    height: 60px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 0;

    .top {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;

      .label {
        width: 65px;
        font-size: 14px;
        color: #333;
        text-align: right;
      }

      .val-content {
        width: 50%;
        height: 40px;
        flex: 1;
        border-bottom: 1px #ccc solid;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-left: 10px;

        .input {
          font-size: 14px;
          color: #666;
          flex: 1;
        }



        span {
          font-size: 14px;
          color: #3c43ec;
        }
      }
    }

    .prompt {
      width: 100%;
      padding-left: 75px;
      display: flex;
      align-items: center;

      span {
        font-size: 12px;
        color: #eb273b;
        margin-left: 5px;
      }
    }
  }
}

/deep/ .nut-textinput-disabled input {
  background-color: #fff;
}

/deep/ .nut-textinput input {
  height: auto;
  padding: 0;
}

.code-input /deep/ input {
  width: 30vw !important;
}
</style>
